import { render } from "./InfoForm.vue?vue&type=template&id=985f6006&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"

import "./InfoForm.vue?vue&type=style&index=0&id=985f6006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985f6006"]])

export default __exports__